import { render } from "./EventSettings.vue?vue&type=template&id=ca644342"
import script from "./EventSettings.vue?vue&type=script&lang=js"
export * from "./EventSettings.vue?vue&type=script&lang=js"
script.render = render

export default script